import { render, staticRenderFns } from "./UserGroupDetails.vue?vue&type=template&id=d0565192&scoped=true"
import script from "./UserGroupDetails.vue?vue&type=script&lang=js"
export * from "./UserGroupDetails.vue?vue&type=script&lang=js"
import style0 from "./UserGroupDetails.vue?vue&type=style&index=0&id=d0565192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0565192",
  null
  
)

export default component.exports